export enum ExitAction {
  ClosedDialog = "CLOSED_DIALOG",
  SentSupportCase = "SENT_SUPPORT_CASE",
}
